import { api } from 'components/api'
import { inboxConversationsPath } from 'components/routes/api'
import type {
  ApiInboxConversationShowResponse,
  InboxConversationDetail
} from '../inboxTypes'
import { mapApiDetailToInboxDetail } from '../inboxTypes'

interface ApiInboxConversationCreateRequest {
  inbox_conversation: {
    review_id?: number
    issue_id?: number
    additional_participant_ids?: number[]
    message: {
      content: string
    }
  }
}

type CreateInboxConversationRequestOptions =
  | { reviewId: number, issueId?: never, additionalParticipantIds?: number[] }
  | { issueId: number, reviewId?: never, additionalParticipantIds?: number[] }

const createInboxConversation = async (
  content: string,
  options: CreateInboxConversationRequestOptions
): Promise<InboxConversationDetail> => {
  const additionalParticipantIds = options.additionalParticipantIds ?? []

  const response = await api.postWithCsrf<
  ApiInboxConversationCreateRequest,
  ApiInboxConversationShowResponse
  >({
    url: inboxConversationsPath(),
    headers: { Accept: 'application/json' },
    data: {
      inbox_conversation: {
        ...(options.reviewId == null ? {} : { review_id: options.reviewId }),
        ...(options.issueId == null ? {} : { issue_id: options.issueId }),
        ...(additionalParticipantIds.length > 0
          ? { additional_participant_ids: additionalParticipantIds }
          : {}),
        message: { content }
      }
    }
  })

  if (response.data.conversation == null) {
    throw new Error('Inbox conversation create response is missing conversation')
  }

  return mapApiDetailToInboxDetail(response.data.conversation)
}

export const createReviewInboxConversation = async (
  reviewId: number,
  content: string,
  additionalParticipantIds: number[] = []
): Promise<InboxConversationDetail> => await createInboxConversation(
  content,
  { reviewId, additionalParticipantIds }
)

export const createIssueInboxConversation = async (
  issueId: number,
  content: string,
  additionalParticipantIds: number[] = []
): Promise<InboxConversationDetail> => await createInboxConversation(
  content,
  { issueId, additionalParticipantIds }
)
